import React from 'react'
import { useDispatch, useSelector } from "react-redux"//Hooks de redux
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import { Box, Typography, useTheme } from '@mui/material'//Se importan elementos de la librería material-ui

import { creditActions, fileActions } from '../../store/actions'
import { useStyles } from './CollectionManagementFormStyles'
import { GenericDialog, CustomLoadingOverlay, Buttons } from '../../components'
import { coreFunctions } from '../../utils'//funciones del nucleo
import { useTranslation } from 'react-i18next'

export default function FinishColManagementFormComponent(props) {
    const { useState, useEffect } = React
    const location = useLocation()
    const localStyles = useStyles()
    const navigate = useNavigate()//Módulo "History" de react router

    const [openHelpDialog, setOpenHelpDialog] = useState(true)//Se muestra/oculta el gif loader 
    const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader 

    const [folioId, setFolioId] = useState("");
    const [folio, setFolio] = useState("");
    const [montoPrestado, setMontoPrestado] = useState("");
    const [nombreGrupo, setNombreGrupo] = useState("Demo");
    const [pagos, setPagos] = useState("");
    const [claveGrupo, setClaveGrupo] = useState("00001");
    const [plazo, setPlazo] = useState("");
    const [periodo, setPeriodo] = useState("");
    const [fechaPrimerPago, setFechaPrimerPago] = useState("");
    const [pagosList, setPagosList] = useState([]);
    const [folioIdCobranzaUnico, setFolioIdCobranzaUnico] = useState("");

    //Redux hooks
    const auth = useSelector(state => state.Authentication)
    const wf = useSelector(state => state.Workflow)
    const cobranzaData = useSelector((state) => state.CobranzaPagos);
    const cobranzaCobro = useSelector((state) => state.CobranzaCobro);
    const file = useSelector(state => state.FileInfo)
    const generaDatUnicCobranza = useSelector(state => state.GeneraCobranzaUnico)

    const dispatch = useDispatch()
    const { t } = useTranslation();

    useEffect(() => {
        console.log("location.state.folioId: ", location.state.folioId)
        console.log("location.state: ", location.state)
        setFolioId(location.state.folioId)
        dispatch(creditActions.GenerarDatosCobranzaUnico(""));
        setLoadView(true)
    }, [])

    useEffect(() => {
        setLoadView(generaDatUnicCobranza.loading)
        if (generaDatUnicCobranza.items != undefined && loadView) {
            console.log("generaDatUnicCobranza-------------------: ", generaDatUnicCobranza)
            setFolioIdCobranzaUnico(generaDatUnicCobranza.items)
            dispatch(creditActions.GetCobranzaPagos({
                File_id: generaDatUnicCobranza.items
            }));
            dispatch(fileActions.GetFileInfo(folioId))
        }
    }, [generaDatUnicCobranza])

    useEffect(() => {
        setLoadView(cobranzaData.loading)
        if (cobranzaData.items != undefined && loadView) {
            // setLoadView(false)
            console.log("cobranzaData-------------------: ", cobranzaData)

            setFolio(cobranzaData.items.Folio)
            setMontoPrestado(cobranzaData.items.MontoPrestamo)
            if (cobranzaData.items.NombreGrupo != null) { setNombreGrupo(cobranzaData.items.NombreGrupo) }
            if (cobranzaData.items.ClaveGrupo != null) { setClaveGrupo(cobranzaData.items.ClaveGrupo) }
            setPagos(cobranzaData.items.MontoPagos)
            setPlazo(cobranzaData.items.Plazo)
            setPeriodo(cobranzaData.items.Periodo)
            setFechaPrimerPago(cobranzaData.items.FechaPrimerPago)
            setPagosList(cobranzaData.items.Pagos)


            dispatch(creditActions.GetCobranzaCobro({
                File_id: folioIdCobranzaUnico,
                ReassignFile: true
            }));
        }
    }, [cobranzaData])

    useEffect(() => {
        setLoadView(cobranzaCobro.loading)
        console.log("cobranzaCobro----Items--New8974-------------------: ", cobranzaCobro)
        if (cobranzaCobro.items != undefined) {
            // setLoadView(false)
            let IdSol = cobranzaCobro.items.FileDataCobro.Id
            console.log("cobranzaCobro----Items--New8974-------------------: ", cobranzaCobro, "  Id de solicitud: ", IdSol)

        }
    }, [cobranzaCobro])

    useEffect(() => {
        setLoadView(file.loading)
        if (file.items != undefined && file.items?.Stage != undefined) {
            // console.log("-- FILE INFO DE INE VERIFICAR PARAMETRO------", file.items)
            // console.log("-- FILE INFO DE INE VERIFICAR PARAMETRO---FILE---", file)          
        }
        if (file.error != undefined) {
            console.log("file.error----: ", file.error)
        }
    }, [file]);


    let handleCobrar = (e) => {
        let stageCurrent = wf.items[0].Stages.find(items => items.Name == "Dashboard")
        let requestItems = {
            Stage: stageCurrent,
            Id: null
        }
        NextStage(requestItems)

        // // let stageName = file.items.Stage.Name
        // // let stageId = file.items.Stage.Id
        // // let stage = file.items.Stage
        // // let folioId = file.items.Id

        // let stageName = cobranzaCobro.items.FileDataCobro.Stage.Name
        // let stageId = cobranzaCobro.items.FileDataCobro.Stage.Id
        // let stage = cobranzaCobro.items.FileDataCobro.Stage
        // let folioId = cobranzaCobro.items.FileDataCobro.Id

        // let nextComponent = coreFunctions.GetLegoNext(stageName)
        // console.log("Next-Stage----Cobranza----: ", { nextComponent, stageName, stageId, stage, folioId })
        // CollectionManagementFunctions.doNextStage({ auth ,navigate,nextComponent, stageName, stageId, stage, folioId })
    }

    let NextStage = (items) => {
        let nextStage = items.Stage
        let stageName = nextStage.Name
        let stageId = nextStage.Id
        let folioId = items.Id
        let stage = items
        // console.log("items-Login: ", items)
        let nextComponent = coreFunctions.GetLegoNext(stageName)
        coreFunctions.DoNextStage({ useNavigate, nextComponent, State: { stageName, stageId, stage, folioId } });
    }

    return (<GenericDialog open={openHelpDialog}
        title="Gestión de cobranza"
        content={<Box sx={{
            display: 'flex',
            position: 'relative',
            height: '80vh',
        }}>
            <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
            <div className={localStyles.containerResult}>
                <div className={localStyles.leftColumnResult}>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className={localStyles.title}>{"Folio"}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                         >{folio}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className={localStyles.title}>{"Nombre de grupo"}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                         >{nombreGrupo}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className={localStyles.title}>{"Clave de grupo"}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                         >{claveGrupo}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className={localStyles.title}>{"Periodo"}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                         >{periodo}</Typography>
                </div>
                <div className={localStyles.rightColumnResult}>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className={localStyles.title}>{"Monto préstado"}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                         >{montoPrestado}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className={localStyles.title}>{"Pagos"}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                         >{pagos}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className={localStyles.title}>{"Plazo"}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                         >{plazo}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className={localStyles.title}>{"Fecha de primer pago"}</Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                         >{fechaPrimerPago}</Typography>
                </div>
            </div>
            <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.titleRed}>Calendario de pagos</Typography>
            <div className={localStyles.containerCalenGral}>
                {pagosList.map(item => {
                    return (
                        <div className={localStyles.containerCalendarResult}>
                            <div className={localStyles.ColumnCalendarResult1}>
                                <Typography variant="subtitle1" gutterBottom
                                     >{item.NumPlazo}</Typography>
                            </div>
                            <div className={localStyles.ColumnCalendarResult2}>
                                <Typography variant="subtitle1" gutterBottom
                                     >{item.FechaPlazo}</Typography>
                            </div>
                            <div className={localStyles.ColumnCalendarResult3}>
                                <Typography variant="subtitle1" gutterBottom
                                     >{item.MontoPlazo}</Typography>
                            </div>
                            <div className={localStyles.ColumnCalendarResult4}>
                                {item.EstatusPago == "Por pagar" ?
                                    <Typography variant="subtitle1" gutterBottom
                                        className={localStyles.subTitleC1}>{item.EstatusPago}</Typography> :
                                    item.EstatusPago == "Sin pagar" ?
                                        <Typography variant="subtitle1" gutterBottom
                                            className={localStyles.subTitleC2}>{item.EstatusPago}</Typography> :
                                        item.EstatusPago == "Pagado" ?
                                            <Typography variant="subtitle1" gutterBottom
                                                className={localStyles.subTitleC3}>{item.EstatusPago}</Typography> :
                                            <Typography variant="subtitle1" gutterBottom
                                                 >{item.EstatusPago}</Typography>
                                }
                            </div>
                        </div>
                    )
                })
                }
            </div>

            <Buttons ConfirmButtonText="OK" onClickConfirm={handleCobrar} />
        </Box>}
    />)
}